import currency from 'currency.js'
const PRODUCT_LIST_CURRENCYJS_VERSION = 5

export const withTwoDecimal = (value: number, version: number): number => {
  // currency.js rounding at 2 decimals
  if (version && version >= PRODUCT_LIST_CURRENCYJS_VERSION) {
    return currency(value).value
  }

  if (version && version >= 4) {
    const epsilon = 0.00001
    return Number((Math.round((value + epsilon) * 100) / 100).toFixed(2))
  }

  return Math.trunc(value * 100) / 100
}

export const calculator = (amount = 0, version: number) => {
  const percentageOf = (percentageValue = 1): number => {
    if (version && version >= PRODUCT_LIST_CURRENCYJS_VERSION) {
      const result = currency(amount)
        .divide(100)
        .multiply(percentageValue).value

      return withTwoDecimal(result, version)
    }

    const result = (amount / 100) * percentageValue
    return withTwoDecimal(result, version)
  }

  const getPercentage = (value: number, version: number): number => {
    if (amount === 0) {
      console.error('Total cannot be zero.')
      return 0
    }

    if (version && version >= PRODUCT_LIST_CURRENCYJS_VERSION) {
      const percent = currency(value).divide(amount).multiply(100).value

      return withTwoDecimal(percent, version)
    }

    const percent = (value / amount) * 100
    return withTwoDecimal(percent, version)
  }

  return {
    percentageOf,
    getPercentage,
  }
}
